import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "./reportingHelpers";

export const Legend = ({ intl }) => (
  <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
    <View style={{
      flexDirection: "column",
      backgroundColor: "lightgrey",
      width: "6mm",
      borderRightWidth: 1,
      marginRight: 4
    }}>
      <Text
        style={{
          transform: "rotate(-90deg)",
          fontSize: 10,
          fontWeight: "bold",
          textTransform: "uppercase",
          marginTop: 16,
          marginLeft: -18,
          width: "18mm"

        }}
      >
        {intl.formatMessage({
          id: "reports.boxscore.table.legend",
          defaultMessage: "Legend",
        })}
      </Text>
    </View>
    <View style={{ flexDirection: "column" }}>
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.no",
          defaultMessage: "No",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.nodesc",
          defaultMessage: "Playing Number",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundsdr",
          defaultMessage: "DR",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundsdrdesc",
          defaultMessage: "Defensive Rebounds",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.bs",
          defaultMessage: "BS",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.bsdesc",
          defaultMessage: "Blocked Shots",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.ef",
          defaultMessage: "EF",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.efdesc",
          defaultMessage: "Efficiency",
        })}
      />
    </View>
    <View style={{ flexDirection: "column" }}>
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.min",
          defaultMessage: "Min",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.mindesc",
          defaultMessage: "Minutes Played",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundstotal",
          defaultMessage: "TOT",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundstotaldesc",
          defaultMessage: "Total Rebounds",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.ba",
          defaultMessage: "BA",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.badesc",
          defaultMessage: "Blocks Against",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.pts",
          defaultMessage: "PTS",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.ptsdesc",
          defaultMessage: "Points",
        })}
      />
    </View>
    <View style={{ flexDirection: "column" }}>
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.madeattempts",
          defaultMessage: "M/A",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.madeattemptsdesc",
          defaultMessage: "Made / Attempts",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.as",
          defaultMessage: "AS",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.asdesc",
          defaultMessage: "Assists",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.foulspf",
          defaultMessage: "PF",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.foulspfdesc",
          defaultMessage: "Personal Fouls",
        })}
      />

      <LegendRow
        shortLabel="*"
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.gamestarters",
          defaultMessage: "Game Starters",
        })}
      />
    </View>
    <View style={{ flexDirection: "column" }}>
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.madepercent",
          defaultMessage: "%",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.madepercentdesc",
          defaultMessage: "Shooting Percentage",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.to",
          defaultMessage: "TO",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.todesc",
          defaultMessage: "Turnovers",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.foulsfd",
          defaultMessage: "FD",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.foulsfddesc",
          defaultMessage: "Fouls Drawn",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.captain",
          defaultMessage: "(C)",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.captaindesc",
          defaultMessage: "Captain",
        })}
      />
    </View>
    <View style={{ flexDirection: "column" }}>
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundsor",
          defaultMessage: "OR",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.reboundsordesc",
          defaultMessage: "Offensive Rebounds",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.st",
          defaultMessage: "ST",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.stdesc",
          defaultMessage: "Steals",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.plusminus",
          defaultMessage: "+/-",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.plusminusdesc",
          defaultMessage: "Plus / Minus",
        })}
      />
      <LegendRow
        shortLabel={intl.formatMessage({
          id: "reports.boxscore.table.dnp",
          defaultMessage: "DNP",
        })}
        longLabel={intl.formatMessage({
          id: "reports.boxscore.table.dnpdesc",
          defaultMessage: "Did Not Play",
        })}
      />
    </View>
  </View>
);

const LegendRow = (props) => (
  <View
    style={{
      ...styles.tableCell,
      textAlign: "left",
      flexDirection: "row",
      width: "4cm",
      height: "4.5mm",
      borderWidth: 0,
    }}
  >
    <Text
      style={{
        ...styles.cellText,
        fontWeight: "bold",
        fontSize: 7.7,
        width: "8mm",
        height: "4.5mm",
        borderWidth: 0,
      }}
    >
      {props.shortLabel}
    </Text>
    <Text
      style={{
        ...styles.cellText,
        fontSize: 7.7,
        height: "4.5mm",
        borderWidth: 0,
      }}
    >
      {props.longLabel}
    </Text>
  </View>
);
